import { Card } from "@/core/components/ui/card";
import { CarouselItem } from "@/core/components/ui/carousel";
import { Skeleton } from "@/core/components/ui/skeleton";

export function CarouselInsightsSkeleton() {
  return (
    <CarouselItem className="basis-2/3">
      <Card className="p-4 border border-[#e2e8f0] rounded-2xl shadow-none h-[150px]">
        <div className="flex gap-2">
          <Skeleton className="w-10 h-10 rounded-full" />

          <div className="flex flex-col">
            <Skeleton className="mb-2 w-24 h-4" />

            <Skeleton className="mb-2 w-[32rem] h-6" />

            <Skeleton className="mt-4 w-36 h-10 rounded-lg" />
          </div>
        </div>
      </Card>
    </CarouselItem>
  );
}
